import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-jupiter-block-dialog',
  templateUrl: './jupiter-block-dialog.component.html',
  styleUrls: ['./jupiter-block-dialog.component.scss']
})
export class JupiterBlockDialogComponent implements OnInit {
  @Output() change: EventEmitter<any> = new EventEmitter<any>();

  ngOnInit(): void {
    this.change.emit(true);
  }

}
